import { BaseError } from "@/domains/errors/kinds/BaseError";

export class TimeoutError extends BaseError {}
